class Constants {
    static readonly MAIL_TYPE = {
        TEST_MAIL: 1,
        APPOINT_MAIL: 2,
        OPTIONAL_MAIL: 3,
        BROADCAST_MAIL: 4,
    }
    static readonly ACCELEDENT_DEVICES = [
        { name: 'AcceleDent', deviceType: 0, value: 'acceleDent', action: false, className: '' },
        { name: 'OrthoPulse', deviceType: 1, value: 'orthoPulse', action: false, className: '' },
        { name: 'Vpro+', deviceType: 1, value: 'vpro+', action: false, className: '' },
        { name: 'Propel', deviceType: 1, value: 'propel', action: false, className: '' },
        { name: 'Surgery', deviceType: 1, value: 'surgery', action: false, className: '' },
        { name: 'Non', deviceType: 1, value: 'non', action: false, className: '' },
    ]

    static readonly TOP_MAIN_TABS = [
        { id: 0, name: 'Face', nameSave: 'Registration-Face' },
        { id: 1, name: 'Tooth', nameSave: 'Registration-Tooth' },
        { id: 2, name: 'Aligner', nameSave: 'Registration-Aligner' },
        { id: 3, name: 'X-ray', nameSave: 'Registration-X-ray' },
        { id: 8, name: 'Dental', nameSave: 'Registration-Dental' },
        { id: 4, name: 'Other', nameSave: 'Registration-Other' },
        { id: 5, name: 'Movie', nameSave: 'Registration-Movie' },
        // 2020-02-28
        // SmileDesign　→　SmileFlame
        // DSD　→　SmileDesign
        { id: 6, name: 'SmileFlame', nameSave: 'smile' },
        { id: 7, name: 'SmileDesign', nameSave: 'dsd' },
    ]

    static readonly TAB_SLIDES = [
        { id: 0, name: 'All', nameSave: 'Registration-All' },
        { id: 1, name: '1', nameSave: 'Registration-Tooth-Front-Right' },
        { id: 2, name: '2', nameSave: 'Registration-Tooth-Front-Front' },
        { id: 3, name: '3', nameSave: 'Registration-Tooth-Side-Left' },
        { id: 4, name: '4', nameSave: 'Registration-Tooth-Side-Upper' },
        { id: 5, name: '5', nameSave: 'Registration-Tooth-Overjet' },
        { id: 6, name: '6', nameSave: 'Registration-Tooth-Lower' },
    ]

    static readonly TAB_FACE_SLIDES = [
        { id: 0, name: 'All', nameSave: 'Registration-Face-All' },
        { id: 1, name: 'Front Smile', nameSave: 'Registration-Face-Front-Smile' },
        { id: 2, name: 'Front Normal', nameSave: 'Registration-Face-Front-Normal' },
        { id: 3, name: 'Side Smile', nameSave: 'Registration-Face-Side-Smile' },
        { id: 4, name: 'Side Normal', nameSave: 'Registration-Face-Side-Normal' },
        { id: 5, name: 'Other 1', nameSave: 'Registration-Face-Other-1' },
        { id: 6, name: 'Other 2', nameSave: 'Registration-Face-Other 2' },
    ]

    static readonly TAB_TOOTH_SLIDES = [
        { id: 0, name: 'All', nameSave: 'Registration-All' },
        { id: 1, name: 'Right', nameSave: 'Registration-Tooth-Front-Right' },
        { id: 2, name: 'Front', nameSave: 'Registration-Tooth-Front-Front' },
        { id: 3, name: 'Left', nameSave: 'Registration-Tooth-Side-Left' },
        { id: 4, name: 'Upper', nameSave: 'Registration-Tooth-Side-Upper' },
        { id: 5, name: 'Overjet', nameSave: 'Registration-Tooth-Overjet' },
        { id: 6, name: 'Lower', nameSave: 'Registration-Tooth-Lower' },
    ]

    static readonly IMAGE_MATRIX_DEFAULT = [1, 0, 0, 1]

    static readonly TREATMENT_MOBILE_TABS = [
        {
            title: 'Face',
            active: false,
            subTitle: [
                { title: 'Front Smile', active: true, parentId: 0, key: 'face-1', data: [] },
                { title: 'Front Normal', active: false, parentId: 0, key: 'face-2', data: [] },
                { title: 'Side Smile', active: false, parentId: 0, key: 'face-3', data: [] },
                { title: 'Side Normal', active: false, parentId: 0, key: 'face-4', data: [] },
                { title: 'Other 1', active: false, parentId: 0, key: 'face-5', data: [] },
                { title: 'Other 2', active: false, parentId: 0, key: 'face-6', data: [] },
            ],
        },
        {
            title: 'Tooth',
            active: true,
            subTitle: [
                { title: 'Front', active: true, parentId: 1, key: 'tooth-front', data: [] },
                { title: 'Upper', active: false, parentId: 1, key: 'tooth-upper', data: [] },
                { title: 'Lower', active: false, parentId: 1, key: 'tooth-lower', data: [] },
                { title: 'Left', active: false, parentId: 1, key: 'tooth-left', data: [] },
                { title: 'Right', active: false, parentId: 1, key: 'tooth-right', data: [] },
                { title: 'Overjet', active: false, parentId: 1, key: 'tooth-overjet', data: [] },
            ],
        },
        {
            title: 'Aligner',
            active: false,
            subTitle: [
                { title: 'Front', active: true, parentId: 2, key: 'aligner-front', data: [] },
                { title: 'Upper', active: false, parentId: 2, key: 'aligner-upper', data: [] },
                { title: 'Lower', active: false, parentId: 2, key: 'aligner-lower', data: [] },
                { title: 'Left', active: false, parentId: 2, key: 'aligner-left', data: [] },
                { title: 'Right', active: false, parentId: 2, key: 'aligner-right', data: [] },
                { title: 'Overjet', active: false, parentId: 2, key: 'aligner-overjet', data: [] },
            ],
        },
        {
            title: 'X-ray',
            active: false,
            subTitle: [
                { title: '1', active: true, parentId: 3, key: 'xp-1', data: [] },
                { title: '2', active: false, parentId: 3, key: 'xp-2', data: [] },
                { title: '3', active: false, parentId: 3, key: 'xp-3', data: [] },
                { title: '4', active: false, parentId: 3, key: 'xp-4', data: [] },
                { title: '5', active: false, parentId: 3, key: 'xp-5', data: [] },
                { title: '6', active: false, parentId: 3, key: 'xp-6', data: [] },
            ],
        },
        {
            title: 'Other',
            active: false,
            subTitle: [
                { title: '1', active: true, parentId: 4, key: 'other-1', data: [] },
                { title: '2', active: false, parentId: 4, key: 'other-2', data: [] },
                { title: '3', active: false, parentId: 4, key: 'other-3', data: [] },
                { title: '4', active: false, parentId: 4, key: 'other-4', data: [] },
                { title: '5', active: false, parentId: 4, key: 'other-5', data: [] },
                { title: '6', active: false, parentId: 4, key: 'other-6', data: [] },
            ],
        },
        {
            title: 'Movie',
            active: false,
            subTitle: [
                { title: '1', active: true, parentId: 5, key: 'movie-1', data: [] },
                { title: '2', active: false, parentId: 5, key: 'movie-2', data: [] },
                { title: '3', active: false, parentId: 5, key: 'movie-3', data: [] },
                { title: '4', active: false, parentId: 5, key: 'movie-4', data: [] },
                { title: '5', active: false, parentId: 5, key: 'movie-5', data: [] },
                { title: '6', active: false, parentId: 5, key: 'movie-6', data: [] },
            ],
        },
    ]

    static readonly ARRAY_GENDER = [
        { name: 'Male', action: false, value: 1 },
        {
            name: 'Female',
            action: false,
            value: 2,
        }]

    static readonly ARRAY_USE_TREATMENT = [
        { name: 'Use', name_lang: 'on', action: true, value: true },
        {
            name: 'Not Use',
            name_lang: 'off',
            action: false,
            value: false,
        }]

    static readonly ARRAY_ALIGNER_MAIL = [
        { name: 'OK', action: true, keyLang: 'ok', value: true },
        {
            name: 'NG',
            action: false,
            keyLang: 'ng',
            value: false,
        }]

    static readonly ARRAY_PUBLICATION_APPROVED = [
        { name: 'OK', action: true, keyLang: 'ok' },
        {
            name: 'NG',
            action: false,
            keyLang: 'ng',
        }]
}

export default Constants



// WEBPACK FOOTER //
// ./src/app/commons/Constants.ts